var map = {
	"./accept.png": 7648,
	"./calendar.png": 6605,
	"./camera.png": 193,
	"./checkmark.png": 2900,
	"./clock.png": 3653,
	"./drop.png": 4518,
	"./drop1.png": 5344,
	"./guidebook.png": 1158,
	"./iphone-mock2.png": 3415,
	"./line.png": 526,
	"./logo_black.png": 5849,
	"./map.png": 6234,
	"./multiple.png": 2868,
	"./number.png": 2313,
	"./options.png": 6604,
	"./pass_fail.png": 7998,
	"./play.png": 3484,
	"./safelyio_icon_logo.png": 9363,
	"./sign.png": 4298,
	"./sign2.png": 1978,
	"./signature.png": 2015,
	"./slider.png": 6237,
	"./test.png": 9543,
	"./text.png": 3521,
	"./wrong.png": 1071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;